export default __webpack_public_path__ + "static/media/romotors-no-image-available-notext.fe195505.jpg";